import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <p
    className={`font-mono text-xs uppercase tracking-[0.28em] text-blau-glow ${className}`}
  >
    {children}
  </p>
);

export const SectionHead = ({ overline, title, sub, align = "left" }) => (
  <Reveal className={align === "center" ? "text-center" : ""}>
    <Overline>{overline}</Overline>
    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight mt-4 text-white">
      {title}
    </h2>
    {sub && (
      <p className="text-base md:text-lg text-gray-400 mt-5 max-w-2xl leading-relaxed">
        {sub}
      </p>
    )}
  </Reveal>
);
